<template>
  <el-container>
    <el-main>
      <div class="setting-security-content">
        <el-form ref="securityPwdForm" class="setting-password-form" :rules="settingPwdRules" :model="settingPwdForm"
          label-width="110px" label-position="left" @submit.native.prevent>
          <el-form-item label="手机号" prop="phoneNumber">
            <el-input class="chang-input" size="mini" readonly disabled v-model="settingPwdForm.phoneNumber"></el-input>
          </el-form-item>
          <el-form-item label="图片验证码">
            <!-- 因为手机号是禁用的，所以图片验证码自动聚焦 -->
            <image-verify-code ref='verifyImg' :focus="false" v-model="settingPwdForm.imageCode" @input="updateImgCode" />
          </el-form-item>
          <el-form-item class="verification" prop="phoneCode" label="手机验证码">
            <el-input v-model="settingPwdForm.phoneCode" placeholder="请输入短信验证码" autocomplete="off"></el-input>
            <el-button type="primary" :disabled="waitToGet" @click="getVerification">{{count}}{{tips}}</el-button>
          </el-form-item>
          <!-- 处理浏览器自动填充密码 -->
          <input class="hidden-input" type="text">
          <input class="hidden-input" type="password">
          <el-form-item label="设置密码" prop="password">
            <el-input class="chang-input" type="password" @input="checkStrength" v-model="settingPwdForm.password"
              placeholder="请输入安全密码" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="confirmPassword">
            <el-input class="chang-input" type="password" v-model="settingPwdForm.confirmPassword" placeholder="请确认安全密码" autocomplete="off"></el-input>
          </el-form-item>
          <div class="strength-check">
            <div class="level-block">
              <div class="level-img" :class="level>=1?'red':''">弱</div>
            </div>
            <div class="level-block">
              <div class="level-img" :class="level>=2?'red':''">中</div>
            </div>
            <div class="level-block">
              <div class="level-img" :class="level>=3?'red':''">强</div>
            </div>
          </div>
          <div class="button-block">
            <el-button type="primary" @click="settingPwd">确认修改</el-button>
            <el-button @click="resetChangePwdForm">重置修改</el-button>
          </div>
        </el-form>
      </div>
    </el-main>
  </el-container>
</template>
<script>
import ImageVerifyCode from './image-verify-code.vue'
import CookieOperation from '@/plugins/cookie'
export default {
  components: {
    ImageVerifyCode
  },
  data () {
    let confirmPwdRules = (rule, value, callback) => {
      let reg = /^(?![a-zA-z]+$)(?!\d+$)(?![!@#$%^&?*]+$)[a-zA-Z\d!@#$%^&?*]+$/
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.settingPwdForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else if (value.length < 6 || value.length > 16) {
        callback(new Error('长度在 6 到 16 个字符'))
      } else if (reg.test(value) === false) {
        callback(new Error('至少包含数字/字母/字符2种组合'))
      } else {
        callback()
        this.canSubmit = false
      }
    }
    let settingPwdRules = (rule, value, callback) => {
      let reg = /^(?![a-zA-z]+$)(?!\d+$)(?![!@#$%^&?*]+$)[a-zA-Z\d!@#$%^&?*]+$/
      if (value === '') {
        callback(new Error('请输入设置密码'))
      } else if (value.length < 6 || value.length > 16) {
        callback(new Error('长度在 6 到 16 个字符'))
      } else if (reg.test(value) === false) {
        callback(new Error('至少包含数字/字母/字符2种组合'))
      } else {
        callback()
        this.canSubmit = false
      }
    }
    return {
      lastRouter: '',
      tenantId: '',
      phoneNumber: '',
      settingPwdForm: {
        phoneNumber: '',
        imageCode: '',
        phoneCode: '',
        password: '',
        confirmPassword: ''
      },
      settingPwdRules: {
        phoneNumber: [{
          required: true,
          message: '手机号不可为空',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: '设置密码不可为空',
          trigger: 'blur'
        },
        {
          validator: settingPwdRules,
          trigger: 'blur'
        }
        ],
        confirmPassword: [{
          required: true,
          message: '确认密码不可为空',
          trigger: 'blur'
        },
        {
          validator: confirmPwdRules,
          trigger: 'blur'
        }
        ]
      },
      canSubmit: '',
      count: '获取验证码',
      tips: '',
      level: '',
      waitToGet: false
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.lastRouter = from.path
    })
  },
  created () {
    const userId = sessionStorage.getItem('userId') || localStorage.getItem('userId')
    // 获取当前用户手机号
    this.$axios.get(`/auth-api/users/${userId}`).then(res => {
      this.settingPwdForm.phoneNumber = res.data.phone
      this.phoneNumber = res.data.phone
    })
    this.tenantId = CookieOperation.get('tenantId')
  },
  methods: {
    // 校验密码强度
    checkStrength () {
      let reg1 = /\W/
      let reg2 = /[A-Za-z]/
      let reg3 = /[0-9]/
      this.level = 0
      if (reg1.test(this.settingPwdForm.password)) {
        // 密码等级增加
        this.level++
      }
      if (reg2.test(this.settingPwdForm.password)) {
        this.level++
      }
      if (reg3.test(this.settingPwdForm.password)) {
        this.level++
      }
    },
    settingPwd () {
      let that = this
      if (!that.settingPwdForm.imageCode) {
        that.$message.error('图片验证码不可为空')
        return
      } else if (!that.settingPwdForm.phoneCode) {
        that.$message.error('短信验证码不可为空')
        return
      } else if (!that.settingPwdForm.password) {
        that.$message.error('密码不可为空')
        return
      } else if (!that.settingPwdForm.confirmPassword) {
        that.$message.error('确认密码不可为空')
        return
      }
      this.$axios.post('/auth-api/login/auth/setSecurityPW', {
        telephone: that.settingPwdForm.phoneNumber,
        telCode: that.settingPwdForm.phoneCode,
        securityPw: that.settingPwdForm.confirmPassword
      })
        .then((res) => {
          that.$message.success('设置成功')
          setTimeout(() => {
            if (that.lastRouter === '/setting-security-password' || that.lastRouter === '/change-password') {
              that.$router.push({ name: 'index' })
            } else {
              that.$router.back(-1)
            }
          }, 2000)
        })
    },
    getVerification () {
      let _this = this
      let params = {
        'imgCode': _this.settingPwdForm.imageCode,
        'type': '3',
        'telephone': _this.settingPwdForm.phoneNumber,
        'tenantId': _this.tenantId
      }
      _this.$axios.get('/auth-api/login/no-auth/getTelCode', {
        params
      })
        .then((res) => {
          _this.count = 60
          _this.tips = '秒后重新获取'
          _this.waitToGet = true
          let timer = setInterval(() => {
            _this.count--
            if (_this.count === 0) {
              clearInterval(timer)
              _this.waitToGet = false
              _this.tips = ''
              _this.count = '重新获取验证码'
            }
          }, 1000)
        })
    },
    resetChangePwdForm () {
      this.$refs.securityPwdForm.resetFields()
      this.settingPwdForm.phoneNumber = this.phoneNumber
      this.settingPwdForm.imageCode = ''
    },
    updateImgCode (value) {
      this.imageCode = value
    }
  }
}

</script>

<style lang="scss">
  .setting-security-content {
    .setting-password-form {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 440px;

      .el-input__inner {
        height: 40px;
      }

      .el-form-item__label {
        line-height: 38px;
      }

      .img-code-label {
        position: absolute;
        top: 65px;
        left: 30px;
        color: #606266;
      }

      .image-verify-code {
        .el-form-item {
          margin-bottom: 0;
        }

        .img-code>input {
          width: 194px;
          box-sizing: border-box;
          color: #606266;
          display: inline-block;
          -webkit-appearance: none;
          background-color: #fff;
          background-image: none;
          border-radius: 4px;
          border: 1px solid #dcdfe6;
        }

        .verify-img {
          margin-left: 11px;
        }
      }

      .verification {
        .el-input {
          width: 194px;
          margin-right: 10px;
        }

        .el-button {
          float: right;
          width: 120px;
          height: 38px;
        }
      }
      .hidden-input {
        opacity: 0;
        width: 0;
        height: 0;
        position: absolute;
      }
    }

    .strength-check {
      position: relative;
      top: -105px;
      left: 450px;
      width: 252px;
      height: 22px;

      .level-block {
        display: inline-block;
        height: 100%;

        .level-img {
          display: inline-block;
          font-size: 13px;
          text-align: center;
          border-radius: 4px;
          height: 22px;
          line-height: 22px;
          width: 70px;
          margin-left: 10px;
          background-color: #f2f1ef;
        }

        .red {
          background-color: #fb615e;
          color: #fff;
        }

        .red-half {
          background: linear-gradient(to right, #fb615e 50%, #f2f1ef 50%);
        }
      }
    }

    .button-block {
      margin-top: 10px;
      text-align: center;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/system/setting-security-password.vue